export default __webpack_public_path__ + "static/media/i-spotify.9949d459.svg";